import {Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {AuthLayout} from './AuthLayout'
import {RegistrationConfirmed} from './components/RegistrationConfirmed'
import {RegistrationDone} from './components/RegistrationDone'
import ResetPassword from './components/ResetPassword'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='login/:token' element={<Login />} />
      <Route path='registration' element={<Registration />} />
      <Route path='registration/done' element={<RegistrationDone />} />
      <Route path='confirm/:token' element={<RegistrationConfirmed />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='recovery/:token/:id' element={<ForgotPassword />} />
      <Route path='password-reset/:token' element={<ResetPassword />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
